var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"danger-600 spacex-4 vertical-centering"},[_c('ErrorIcon'),_c('span',[_vm._v(_vm._s(_vm.error || _vm.$t('An error has occurred')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }